<template>
  <tr :class="['more_info_content', {'open': isOpened}]">
    <td></td>
    <td></td>
    <td class="no_padding_left">
      <p v-if="item.type === 'PAIRING_TEMPLATE_BROADCAST_TYPE'">
        <label>{{translations.tvStations}}</label>
        <app-select
            selectId="tvStationsSelect"
            name="tvStationsSelect"
            :options="tvStationsOptions"
            v-model="tvStationsSelect"
        />
      </p>
      <p v-else>
        <label>{{translations.epgSource + (item.type === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE' ? ' *' : '')}}</label>
        <app-select
            selectId="epgSourceSelect"
            name="epgSourceSelect"
            :options="epgSources.map(v => ({name: v.name, value: v._id}))"
            v-model="epgSelect"
        />
      </p>
    </td>
    <td>
      <app-input
          id="expression"
          name="expression"
          :label="translations.expression"
          inputSize="255"
          type="text"
          v-model.trim="expression"
      />
    </td>
    <td>
      <app-input
          id="extraCriteria"
          name="extraCriteria"
          :label="translations.extraCriteria"
          inputSize="255"
          type="text"
          v-model.trim="extraCriteria"
      />
    </td>
    <td></td>
    <td></td>
    <td>
      <p>
        <input
            class="btn"
            type="submit"
            :value="translations.save"
            @click.stop.prevent="update"
        />
      </p>
    </td>
    <td></td>
  </tr>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import apiMessagesMixin from "@/mixins/apiMessagesMixin"

export default {
  name: 'templates-editable-row',
  mixins: [
    apiMessagesMixin
  ],
  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    copyItem: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true,
      default: null
    }
  },
  created() {
    this.tvStationsSelect = this.item.tvStationId
    this.epgSelect = this.item.epgSourceId
    this.expression = this.item.expression
    if (this.item.extraCriteria.length !== 0) {
      this.extraCriteria = JSON.stringify(this.item.extraCriteria)
    }
  },
  data() {
    return {
      epgSelect: '',
      tvStationsSelect: '',
      expression: '',
      extraCriteria: ''
    }
  },
  computed: {
    ...mapState({
      allTvStations: state => state.tvStations.allTvStations,
      storedEpgSources: state => state.epgSources.epgSources
    }),
    epgSources() {
      if (this.item.type === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE') {
        return this.storedEpgSources
      } else {
        return [
          {
            name: this.translations.none,
            value: null
          },
          ...this.storedEpgSources
        ]
      }
    },
    translations() {
      return {
        none: this.$gettext('Nevybráno'),
        extraCriteria: this.$gettext('Extra kritéria'),
        epgSource: this.$gettext('Epg zdroj'),
        tvStations: this.$gettext('Tv stanice'),
        expression: this.$gettext('Výraz *'),
        save: this.$gettext('Uložit'),
        expressionError: this.$gettext('Výraz musí být vyplněn'),
        extraCriteriaError: this.$gettext('Extra kritéria musí být ve správném JSON formátu'),
        tvStationError: this.$gettext('Tv stanice musí být vybrána'),
        epgSourceError: this.$gettext('Zdroj epg musí být vybrán')
      }
    },
    tvStationsOptions() {
      return [{ name: this.translations.none, value: '' }, ...this.allTvStations.map(v => ({ name: v.name, value: v._id }))]
    }
  },
  methods: {
    ...mapActions([
      'appShowErrors',
      'appClearErrors',
      'updatePairingTemplate',
      'createPairingTemplate'
    ]),
    handleResponseIfError(response) {
      if (response.status === 500) {
        this.appShowErrors([this.errorTrans.serverError])
      }

      if (response.status === 422) {
        if (response.data.message === 'Model errors: pairingTemplateRegexInvalid') {
          this.appShowErrors([this.apiMessagesMap.pairingTemplateRegexInvalid])
        } else {
          this.appShowErrors([this.apiMessagesMap.pairingTemplateMustBeUnique])
        }
      }

      this.apiErrors = response.data.error
      if (this.apiErrors && this.apiErrors.length) {
        this.mapApiErrorsToErrors()

        if (response.status === 422) {
          this.appShowErrors([this.errorTrans.formError])
        }
      }
    },
    async update(e) {
      this.errors.clear();

      if (this.typeSelect === 'PAIRING_TEMPLATE_CONTENT_ID_TYPE' && this.epgSelect === '') {
        this.appShowErrors([this.translations.epgSourceError]);
        return;
      }

      if (this.expression === '') {
        this.appShowErrors([this.translations.expressionError]);
        return;
      }

      if (this.extraCriteria && !this.checkJson(this.extraCriteria)) {
        this.appShowErrors([this.translations.extraCriteriaError]);
        return;
      }

      await this.$validator.validateAll();
      if (this.errors.items.length > 0) {
        this.appShowErrors(this.errors.items.map(v => v.msg));
        return;
      }

      const { elements } = e.target;
      const data = {
        showId: Number(this.$route.params.id),
        type: this.item.type,
        expression: this.expression,
        extraCriteria: this.extraCriteria,
        tvStation: this.tvStationsSelect === '' ? null : this.tvStationsSelect,
        epgSource: this.epgSelect === '' ? null : this.epgSelect
      };

      let result = null;
      if (this.copyItem) {
        result = await this.createPairingTemplate({
          params: {
            id: this.item._id
          },
          data: data
        }).catch(err => err.response);
      } else {
        result = await this.updatePairingTemplate({
          params: {
            id: this.item._id
          },
          data: data
        }).catch(err => err.response);
      }

      this.handleResponseIfError(result);

      if (result.status === 201 || result.status === 200) {
        this.$validator.reset();
      }
      this.$emit('updatedRow');
    },
    checkJson(json) {
      let isJsonValid = true;
      try {
        JSON.parse(json);
      } catch {
        isJsonValid = false;
      }

      return isJsonValid;
    }
  }
}
</script>
